import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { messaging } from "../services/messaging.js";

export function AddByInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current || !token) return;
    started.current = true;
    void messaging
      .addContactByInvite(token)
      .then((contact) => nav(`/chat/${contact.peerUserId}`, { replace: true }))
      .catch((e: unknown) => setError(e instanceof Error ? e.message : "Could not add contact."));
  }, [token, nav]);

  return (
    <div className="center">
      <div className="card">
        <h1>{error ? "Couldn't add contact" : "Adding contact…"}</h1>
        {error && <div className="error">{error}</div>}
        <Link to="/"><button className="ghost">Go home</button></Link>
      </div>
    </div>
  );
}
